import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Más Sobre Mi`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Ama lo que haces 👩‍💻`}</p>
    </blockquote>
    <p>{`Lo más maravilloso que puede hacer un ser humano es crear, pero crear valor,
para sí mismo y para los demás, es ahí donde se le da más sentido a lo que se dice, amar lo que haces. Ya que disfrutas tanto el proceso en hacerlo como el resultado mismo que das, porque sabes lo que realmente vale,
y que también sabes que lo harás incluso mejor. `}</p>
    <p>{`La mejora continua es un hecho y es así como se mueve la tecnología 🤖.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      